import * as yup from "yup";

export const VALIDATION_SCHEMA = yup.object({
  title: yup.string().required("This field is required!"),
  description: yup.string(),
});

export enum ERiskMoveDirection {
  UP = "up",
  DOWN = "down",
}
